import { RxCollection, RxCollectionCreator, RxJsonSchema } from "rxdb"
import { ItemModel } from "src/util/types/dataModels/itemModel"

//region Types

export type ItemModelCollection = RxCollection<ItemModel>

//endregion

/**
 * Schema for item model collections
 */
export const itemModelSchema: RxJsonSchema<ItemModel> = {
  title: "Item model schema",
  description: "Item models for a particular user",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    designation: { type: "string", maxLength: 200 },
    main_image: { ref: "attachment", type: "string", maxLength: 36 },
    model_code: { type: "string", maxLength: 200 },
    type_description: { type: "string" },
    manufacturer: { type: "string", maxLength: 200 },
    item_class: { ref: "item_class", type: "string", maxLength: 36 },
    restricted_to_procedures: {
      type: "array",
      items: {
        type: "string",
      },
    },
    attachments: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "designation", "model_code", "item_class"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const itemModelCollectionCreator: RxCollectionCreator = {
  schema: itemModelSchema,
}
